/**
 * Enum de IDs dos sistemas do monorepo
 *
 * IMPORTANTE: Os IDs devem corresponder aos registros na tabela 'sistema' do banco de dados
 */
export enum SistemaEnum {
  /**
   * Portal Nomoh - Sistema mestre de gerenciamento
   * Apps: nomoh-administrador, nomoh-cliente
   * API: api-nomoh
   */
  Nomoh = 'NOMOH',

  /**
   * Bardo - Sistema de agendamentos
   * Apps: bardo-administrador, bardo-cliente
   * API: api-bardo
   */
  Bardo = 'BARDO',

  /**
   * API WhatsApp - Sistema de integração com WhatsApp
   * Apps: N/A (apenas backend)
   * API: api-zap
   */
  ApiZap = 'API_ZAP',

  NomohCliente = 'NOMOH_CLIENTE',
}

/**
 * Helper para obter o nome do sistema a partir do ID
 */
export const getSistemaNome = (id: SistemaEnum): string => {
  switch (id) {
    case SistemaEnum.Nomoh:
      return 'Nomoh';
    case SistemaEnum.Bardo:
      return 'Bardo';
    case SistemaEnum.ApiZap:
      return 'API Zap';
    case SistemaEnum.NomohCliente:
      return 'Nomoh Cliente';
    default:
      return 'Desconhecido';
  }
};

/**
 * Helper para validar se um número é um SistemaId válido
 */
export const isValidSistemaEnum = (id: string): id is SistemaEnum => {
  return Object.values(SistemaEnum).includes(id as SistemaEnum);
};

// Alias temporário para compatibilidade com usos legados
export { SistemaEnum as SistemaId };
export const isValidSistemaId = isValidSistemaEnum;
